
import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { ProjectTypesService } from '../../shared/services/project-types.service';
import { Profile } from 'src/app/models/Profile';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { environment } from 'src/environments/environment';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};

@Component({
  standalone: false,
  selector: 'app-configuration-dialog',
  templateUrl: './configuration-dialog.component.html',
  styleUrls: ['./configuration-dialog.component.css'],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }],
})
export class ConfigurationDialogComponent implements OnInit {

  variables: any;

  local_data: any;
  standardInvalidInput: boolean = false;
  nameInvalidInput: boolean = false;
  effortInvalidInput: boolean = false;

  standardErrorMessage: string = '';
  nameErrorMessage: string = '';
  effortErrorMessage: string = '';

  formGroup1: any;

  effort = '';

  otherType = false; //Flag to check if the user will add a custom input or use a predefined type.
  riskInputEffort: any;
  isEdit = false;
  list: any;
  listInDB: any;
  profiles: Profile[] = [];
  centers: string[] = [];
  filteredProfiles: Profile[] = [];

  itemIndex: number = 0;

  constructor(private projectTypesService: ProjectTypesService,
    public dialogRef: MatDialogRef<ConfigurationDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };

    //Add default values to predefined list
    this.list = Array.isArray(this.local_data.list) ? this.local_data.list : [];
    this.listInDB = Array.isArray(this.local_data.listInConfigs) ? this.local_data.listInConfigs : [];
    this.profiles = Array.isArray(this.local_data.profiles) ? this.local_data.profiles : [];
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;

      this.effort = this.variables?.hours;
    });


    this.isEdit = this.local_data.isEdit;
    this.itemIndex = this.local_data.itemIndex;

    this.formGroup1 = this._formBuilder.group({
      standardCtrl: [{ value: '' }, Validators.required],
      nameCtrl: [{ value: '' }, Validators.required],
      effortCtrl: ['', [Validators.required, Validators.min(0), Validators.max(environment.complexityMaxHours)]],
      centerCtrl: [''],
      profileCtrl: [''],
    });

    this.centers = [...new Set(this.profiles.map(p => p.center).filter(c => !!c))] as string[];
    this.filteredProfiles = this.profiles;

    if (this.isEdit) {
      this.formGroup1.get('effortCtrl')?.setValue(this.local_data.item.complexity);
      this.formGroup1.get('profileCtrl')?.setValue(this.local_data.item.profileId || '');
      const existingProfile = this.profiles.find(p => p.id === this.local_data.item.profileId);

      if (existingProfile?.center) {
        this.formGroup1.get('centerCtrl')?.setValue(existingProfile.center);
        this.filteredProfiles = this.profiles.filter(p => p.center === existingProfile.center);
      } else {
        this.filteredProfiles = this.profiles;
      }

      const existsInDB = this.list.some((el: { name: string; }) => el.name === this.local_data.item.name);

      if (existsInDB) {
        this.formGroup1.get('standardCtrl')?.setValue(this.local_data.item.name);
      }
      else {
        this.otherType = true
        this.formGroup1.get('nameCtrl')?.setValue(this.local_data.item.name);
        this.formGroup1.get('standardCtrl')?.setValue(this.variables.other);
      }

    }
    else {
      this.formGroup1.get("standardCtrl").valueChanges.subscribe((result: any) => {
        if (result === this.variables.other) {
          this.otherType = true;
          this.formGroup1.get('nameCtrl')?.setValue('');
          this.formGroup1.get('effortCtrl').setValue('');
        }
        else {
          this.otherType = false;
        }
      })
    }
  }


  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;

    if (!this.formGroup1.valid) {

      if (formGroup.standardCtrl === '') {
        this.standardInvalidInput = true;
        this.standardErrorMessage = this.variables.chooseProjectType;
        valid = false;
      }
      if ((formGroup.nameCtrl === '' || formGroup.nameCtrl === undefined) && this.otherType === true) {
        this.nameInvalidInput = true;
        this.nameErrorMessage = this.variables.insertName;
        valid = false;
      }

      if ((formGroup.effortCtrl < 0 || formGroup.effortCtrl > environment.complexityMaxHours || !formGroup.effortCtrl)) {
        this.effortInvalidInput = true;
        this.effortErrorMessage = this.variables.numberBetweenZeroAndMaxHours + environment.complexityMaxHours;
        valid = false;
      }
      return
    }

    this.listInDB.some((item: any, index: number) => {

      if (index != this.itemIndex) {

        if (item.name === formGroup.nameCtrl) {
          this.nameInvalidInput = true;
          this.nameErrorMessage = this.variables.alreadyExists;
          valid = false;
        } else if (item.name === formGroup.standardCtrl) {
          this.standardInvalidInput = true;
          this.standardErrorMessage = this.variables.alreadyExists;
          valid = false;
        }
        return;
      }
    });

    if (valid) {
      this.local_data.name = this.otherType ? formGroup.nameCtrl : formGroup.standardCtrl;
      this.local_data.complexity = formGroup.effortCtrl;
      this.local_data.profileId = formGroup.profileCtrl || null;

      this.dialogRef.close({ data: this.local_data });
    }
    else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 2000);

    }
  }

  onCenterChange(center: string): void {
    if (center) {
      this.filteredProfiles = this.profiles.filter(p => p.center === center);
    } else {
      this.filteredProfiles = this.profiles;
    }
    this.formGroup1.get('profileCtrl')?.setValue('');
  }
}
